import axios from 'axios' // 引入axios
import QS from 'qs' // 引入qs模块，用来序列化post类型的数据
import aes from '../../static/js/encrypt.js'
import code from '../../static/js/RequestCode.js'

const time = 10000

axios.defaults.timeout = time
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'

var getToken = function () {
  if (sessionStorage.getItem('access_token')) {
    return sessionStorage.getItem('access_token')
  } else if (localStorage.getItem('access_token')) {
    return localStorage.getItem('access_token')
  } else {
    return ''
  }
}
// get方法，对应get请求
// @param {String} url [请求的url地址]
// @param {Object} params [请求时携带的参数]
export function get (url, params) {
  return new Promise((resolve, reject) => {
    axios({ // 进行post请求
      method: 'get',
      url: url,
      params: params, // json转字符串 参数传递
      headers: {
        // token:localStorage.getItem("token")
      }
    }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
};

// post方法，对应post请求
// @param {String} url [请求的url地址]
// @param {Object} params [请求时携带的参数]
export function post (url, params) {
  return new Promise((resolve, reject) => {
    axios({ // 进行post请求
      method: 'post',
      url: url,
      data: params, // json转字符串 用于适合'{"name":"hehe","age":10}'的传参
      headers: {
        // token:localStorage.getItem("token")
      }
    })
    // axios.post('/Api/Article/ArticleList',Qs.stringify({sign:'sign',ceshi:'ceshi'}))
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

export function newget (url, params) {
  return new Promise((resolve, reject) => {
    var newparams = params
    if (newparams) {
      for (let i = 0; i < Object.keys(params).length; i++) {
        Object.keys(newparams)[i] = aes.UrlEncode(params[Object.keys(params)[i]])
      }
    }
    axios({ // 进行post请求
      method: 'get',
      url: url,
      params: newparams, // json转字符串 参数传递
      headers: {
        'client-type': aes.clientType,
        'sign': aes.headersSign(),
        'access-token': getToken()
      }
    }).then(res => {
      if (res.data.code == code.havenomobile) {
        setTimeout(() => {
          top.location.href = window.location.protocol + '//' + window.location.host + '/user/bind.html'
        },
        1500)
      }
      resolve(res.data)
    }).catch(err => {
      reject(err.data)
    })
  })
};

export function newpost (url, params, header = {}, timeout = 0) {
  // url = url.replace('https://newapidev.dianyuan.com/', 'http://192.168.1.83/')

  header = header || {}
  timeout = timeout || time
  let myHeader = Object.assign({
    'client-type': aes.clientType,
    'sign': aes.headersSign(),
    'access-token': getToken()
  }, header)
  return new Promise((resolve, reject) => {
    axios({ // 进行post请求
      method: 'post',
      url: url,
      data: params, // json转字符串 参数传递
      headers: myHeader,
      timeout: timeout
    }).then(res => {
      if (res.data.code == code.havenomobile) {
        setTimeout(() => {
          top.location.href = window.location.protocol + '//' + window.location.host + '/user/bind.html'
        },
        1500)
      }
      resolve(res.data)
    }).catch(err => {
      reject(err.data)
    })
  })
};
